import { addModalKeyDownHandler } from "../utils/a11y";

export default class BioModal {
  constructor(elem) {
    this.elem = elem;
    this.closeBtn = this.elem.querySelector('.js-bm-close');
    this.leadershipLP = this.elem.dataset.leadershipLp;
    this.firstFocusableElement = this.closeBtn;
    this.lastFocusableElement = this.closeBtn;
    this.referrer = document.referrer;
    this.environments = ['mlpsitestg', 'mlpsitestg', 'mlpsite', 'mlp', 'mpgopsdev', 'mpgopsstaging', 'localhost', 'mpg'];

    // if the referrer contains any of the environments, it is an internal referrer
    this.isInternalReferrer = this.environments.some(env => this.referrer.includes(env));
  }


  populateCloseBtn() {
    if (this.isInternalReferrer) {
      if (this.referrer.includes('people/leadership')) {
        this.closeBtn.href = this.leadershipLP;
      } else {
        this.closeBtn.href = 'javascript:history.back()'; 
      }
    } else {
      this.closeBtn.href = this.leadershipLP;
    }
  }

  handleModalClick(event) {
    const rect = this.elem.getBoundingClientRect();
    const isInDialog = (rect.top <= event.clientY && event.clientY <= rect.top + rect.height &&
      rect.left <= event.clientX && event.clientX <= rect.left + rect.width);

    if (isInDialog) return;

    if (this.isInternalReferrer) {
      if (this.referrer.includes('people/leadership')) {
        window.location.href = this.leadershipLP;
      } else {
        history.back(); 
      }
    } else {
      window.location.href = this.leadershipLP;
    }
  }

  init() {
    this.populateCloseBtn();
    addModalKeyDownHandler(this.elem, this.firstFocusableElement, this.lastFocusableElement);
    this.elem.showModal();
    document.body.classList.add('no-scroll');
    this.elem.addEventListener('click', this.handleModalClick.bind(this));
  }
}